// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!./bivariate-choropleth.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!./coxcomb.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js!./flow.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js!./pie.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../node_modules/css-loader/dist/cjs.js!./spike.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../node_modules/css-loader/dist/cjs.js!./ternary.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../node_modules/css-loader/dist/cjs.js!./spark.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-legend-background {
    fill: white;
    opacity: 0.7;
    rx: 0;
    ry: 0;
    pointer-events: none;
}

/* titles */
.em-legend-title {
    font-weight: bold;
    font-size: 15px;
    fill: #4c4b4b;
}

.em-size-legend-title {
    font-size: 15px;
    fill: #666;
}

.em-color-legend-title {
    font-size: 15px;
    fill: #696969;
}

.em-width-legend-title {
    font-size: 15px;
    fill: #696969;
}

.em-legend-subtitle {
    font-size: 15px;
    fill: #696969;
    opacity: 0.8;
}

/* labels */
.em-legend-label {
    font-size: 14px;
    stroke: none;
    fill: #5e5e5e;
    dominant-baseline: unset;
}

.em-legend-label-max,
.em-legend-label-min,
.em-legend-label-no-data {
    fill: #707070;
}

.em-legend-label-max:hover,
.em-legend-label-min:hover,
.em-legend-label-no-data:hover {
    font-weight: bold;
}

/* ticks */
.em-legend-tick {
    stroke: #696969;
    stroke-width: 1;
}

/* swatch separator */
.em-legend-separator {
    stroke: white;
    stroke-width: 1;
}

/* cursor: pointer */
.em-legend-gradient {
    cursor: pointer;
}
.em-bivariate-square,
.em-legend-rect {
    cursor: pointer;
}
.em-legend-histogram-bar {
    cursor: pointer;
}

/* hover */
.em-bivariate-square:hover,
.em-legend-rect:hover {
    stroke-width: 2;
    stroke: red;
}

.em-legend-diverging-line {
    stroke: #696969;
}
.em-legend-background {
    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.5));
    opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/css/legend/legend.css"],"names":[],"mappings":"AAQA;IACI,WAAW;IACX,YAAY;IACZ,KAAK;IACL,KAAK;IACL,oBAAoB;AACxB;;AAEA,WAAW;AACX;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,wBAAwB;AAC5B;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,eAAe;AACnB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA,UAAU;AACV;;IAEI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;AACA;IACI,mDAAmD;IACnD,YAAY;AAChB","sourcesContent":["@import 'bivariate-choropleth.css';\r\n@import 'coxcomb.css';\r\n@import 'flow.css';\r\n@import 'pie.css';\r\n@import 'spike.css';\r\n@import 'ternary.css';\r\n@import 'spark.css';\r\n\r\n.em-legend-background {\r\n    fill: white;\r\n    opacity: 0.7;\r\n    rx: 0;\r\n    ry: 0;\r\n    pointer-events: none;\r\n}\r\n\r\n/* titles */\r\n.em-legend-title {\r\n    font-weight: bold;\r\n    font-size: 15px;\r\n    fill: #4c4b4b;\r\n}\r\n\r\n.em-size-legend-title {\r\n    font-size: 15px;\r\n    fill: #666;\r\n}\r\n\r\n.em-color-legend-title {\r\n    font-size: 15px;\r\n    fill: #696969;\r\n}\r\n\r\n.em-width-legend-title {\r\n    font-size: 15px;\r\n    fill: #696969;\r\n}\r\n\r\n.em-legend-subtitle {\r\n    font-size: 15px;\r\n    fill: #696969;\r\n    opacity: 0.8;\r\n}\r\n\r\n/* labels */\r\n.em-legend-label {\r\n    font-size: 14px;\r\n    stroke: none;\r\n    fill: #5e5e5e;\r\n    dominant-baseline: unset;\r\n}\r\n\r\n.em-legend-label-max,\r\n.em-legend-label-min,\r\n.em-legend-label-no-data {\r\n    fill: #707070;\r\n}\r\n\r\n.em-legend-label-max:hover,\r\n.em-legend-label-min:hover,\r\n.em-legend-label-no-data:hover {\r\n    font-weight: bold;\r\n}\r\n\r\n/* ticks */\r\n.em-legend-tick {\r\n    stroke: #696969;\r\n    stroke-width: 1;\r\n}\r\n\r\n/* swatch separator */\r\n.em-legend-separator {\r\n    stroke: white;\r\n    stroke-width: 1;\r\n}\r\n\r\n/* cursor: pointer */\r\n.em-legend-gradient {\r\n    cursor: pointer;\r\n}\r\n.em-bivariate-square,\r\n.em-legend-rect {\r\n    cursor: pointer;\r\n}\r\n.em-legend-histogram-bar {\r\n    cursor: pointer;\r\n}\r\n\r\n/* hover */\r\n.em-bivariate-square:hover,\r\n.em-legend-rect:hover {\r\n    stroke-width: 2;\r\n    stroke: red;\r\n}\r\n\r\n.em-legend-diverging-line {\r\n    stroke: #696969;\r\n}\r\n.em-legend-background {\r\n    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.5));\r\n    opacity: 0.9;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
